import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  private http = inject(HttpClient);
  private apiUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.apiUrl = this.config.apiUrl;
  }

  getList(body: any) {
    return this.http.post<any>(this.apiUrl + ApiUrls.getSignatures, body);
  }

  getById(id: number) {
    return this.http.get<any>(`${this.apiUrl}${ApiUrls.getSignatureById}/${id}`);
  }

  getByManagerId(userId: number) {
    return this.http.get<any>(
      `${this.apiUrl}${ApiUrls.getSignatureByManagerId}/${userId}`
    );
  }

  create(body: any) {
    return this.http.post<BaseResponse>(this.apiUrl + ApiUrls.createSignature, body);
  }

  update(id: number, body: any) {
    return this.http.post<BaseResponse>(`${this.apiUrl}${ApiUrls.updateSignature}/${id}`, body);
  }

  delete(id: number) {
    return this.http.post<BaseResponse>(`${this.apiUrl}${ApiUrls.deleteSignature}/${id}`, {});
  }
}
